import React, {
	useEffect,
	useState,
} from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { SET_SELECTED_APP, SIGN_IN_HOST } from '../stores/actions/session';
import { APP } from '../stores/session-status';
import RedirectSplash from './redirect/redirect-splash';

export default function StreamsTokenLogin() {
	const { token } = useParams();
	const [hasFailure, setHasFailure] = useState(false);
	const dispatch = useDispatch();

	const queryString = window.location.search;
	const urlParams = new URLSearchParams(queryString);
	const page = urlParams.get('page') ?? '/producer';

	useEffect(() => {
		const loginWithToken = async () => {
			const result = await fetch(
				`${process.env.REACT_APP_API_HOST}/v2/greenroom/producer/login-with-streams-token/${token}`,
				{ method: 'POST' },
			);

			if (result.ok) {
				const data = await result.json();
				// using setAppSignedInWith is causing this to fail, so using the hardcoded version
				dispatch({
					type: SET_SELECTED_APP,
					payload: APP.EVENTS,
				});

				// we need to now sign in and then forward to producer...
				dispatch({
					type: SIGN_IN_HOST,
					promise: new Promise((resolve) => {
						resolve({
							token: data.token,
							events_channels: data.channels,
							events_legacy_channels: [],
							gr_channels: [],
							selectedApp: 'events',
						});
					}),
				});
				window.location.href = page;
			} else { // there has been an error alert the user
				setHasFailure(true);
			}
		};

		loginWithToken()
			.catch(console.error);
	}, [token]);

	return (
		<RedirectSplash hasFailure={hasFailure} />
	);
}
